export const API_URL = process.env.REACT_APP_API_URL || '/api';
export const CREATIVE_ENGINE_API_URL = process.env.REACT_APP_CREATIVE_ENGINE_API_URL || '/creative-api';

export const URLS = {
    SIGN_IN: '/accounts/token/',
    REGISTER: '/accounts/register/',
    REFRESH: '/accounts/token/refresh/',
    CONFIRM_EMAIL: '/accounts/confirm-email/',
    REFETCH_EMAIL_CODE: '/accounts/confirm-email/refetch-code/',
    PASSWORD_RESET: '/accounts/password-reset/',
    UPDATE_ONBOARDING_STEP: '/accounts/update-onboarding-step/',
    PASSWORD_CONFIRM_RESET: '/accounts/password-reset-confirm/',
    CHANGE_EMAIL: '/accounts/change-email/request/',
    CHANGE_EMAIL_CONFIRM: '/accounts/change-email/confirm/',
    USER: '/accounts/me/',
    SUBSCRIPTIONS: '/subscriptions/plans/',
    SUBSCRIPTIONS_CUSTOM_PLAN_SETTINGS: '/subscriptions/custom-plan-settings/',
    SUBSCRIPTIONS_CREATE_PAYMENT: '/subscriptions/create-payment/',
    SUBSCRIPTIONS_CANCEL: '/subscriptions/cancel/',
    SUBSCRIPTIONS_VALIDATE_PROMO_CODE: '/subscriptions/validate-promo-code/',
    SUBSCRIPTIONS_MY_PROMOCODE: '/subscriptions/my-promocode/',
    SUBSCRIPTIONS_MY_REFERRALS: '/subscriptions/my-referrals/',
    PROJECTS: '/projects/',
    PROJECTS_CREATE: '/projects/create/',
    CHATS: '/chats/',
    KEYWORDS: '/keywords/',
    BUNDLES: '/chats/bundles/',
    BUNDLES_CREATE: '/chats/bundles/create/',
    MESSAGES: '/messages/',
    DESCRIPTION: '/accounts/update-description',
    NICHE_ANALYSIS: '/projects/niche-analysis/',
    LOCATION_SEARCH: '/projects/locations/search/',
    LOCATION_GEOCODE: '/projects/locations/geocode/',
    LEAD_EXAMPLES: '/lead-streams/examples/',
    SAVE_NICHE_ANALYSIS: '/projects/save-niche-analysis/',
    SAVE_SELECTED_LEADS: '/projects/save-selected-leads/',
    SAVE_SELECTED_CHATS: '/projects/save-selected-chats/',
    SAVE_SELECTED_COLLECTIONS: '/projects/save-selected-collections/',
    GET_PROJECT_RECOMMENDED_COLLECTIONS: '/projects',
    COMMENTING_DASHBOARD: '/commenting/dashboard/',
    COMMENTING_CAMPAIGNS: '/commenting/campaigns/',
    COMMENTING_DRAFTS: '/commenting/drafts/',
    COMMENTING_TELEGRAM_CONNECTION: '/commenting/telegram/connection/',
    COMMENTING_TELEGRAM_DIALOGS: '/commenting/telegram/dialogs/',
    COMMENTING_TELEGRAM_AUTH_START: '/commenting/telegram/auth/start/',
    COMMENTING_TELEGRAM_AUTH_VERIFY: '/commenting/telegram/auth/verify/',
    CREATIVE_BRANDS: '/api/v1/brands/',
    CREATIVE_PRODUCTS: '/api/v1/products/',
    CREATIVE_AUDIENCES: '/api/v1/audiences/',
    CREATIVE_PROJECTS: '/api/v1/projects/',
    CREATIVE_ITEMS: '/api/v1/creatives/',
    CREATIVE_JOBS: '/api/v1/jobs/',
    CREATIVE_ASSETS: '/api/v1/assets/',
    CREATIVE_HEALTH: '/api/v1/health/',
    YANDEX_DIRECT_CONNECTION: '/yandex-direct/connection/',
    YANDEX_DIRECT_OAUTH_START: '/yandex-direct/oauth/start/',
    YANDEX_DIRECT_CONNECTION_CHECK: '/yandex-direct/connection/check/',
    YANDEX_DIRECT_CONFIRM_ADVERTISER_DATA: '/yandex-direct/connection/confirm-advertiser-data/',
    YANDEX_DIRECT_PROJECTS: '/yandex-direct/projects',
};
